import { useState } from 'react';
import type { ChangeEvent, ReactNode } from 'react';

export interface InputProps {
  label?: string;
  placeholder?: string;
  value?: string;
  hint?: string;
  invalid?: boolean;
  icon?: ReactNode;
  type?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export function Input({
  label,
  placeholder,
  value,
  hint,
  invalid = false,
  icon,
  onChange,
  type = 'text',
}: InputProps) {
  const [focus, setFocus] = useState(false);
  const border = invalid
    ? '1px solid var(--danger)'
    : focus
      ? '1px solid var(--line-primary)'
      : '1px solid var(--line-strong)';
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontFamily: 'var(--font-body)' }}>
      {label && <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-2)' }}>{label}</span>}
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 9,
          height: 40,
          padding: '0 12px',
          background: 'var(--surface-1)',
          border,
          borderRadius: 'var(--r-md)',
          boxShadow: focus ? '0 0 0 3px var(--primary-tint)' : 'none',
          transition: 'none',
        }}
      >
        {icon}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          style={{
            flex: 1,
            minWidth: 0,
            background: 'transparent',
            border: 'none',
            outline: 'none',
            color: 'var(--text-1)',
            fontSize: 13,
            fontFamily: 'inherit',
          }}
        />
      </span>
      {hint && <span style={{ fontSize: 11, color: invalid ? 'var(--danger)' : 'var(--text-3)' }}>{hint}</span>}
    </label>
  );
}
